import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import useUser from "../../hooks/useUser";
import AppShell from "../../components/app-shell/AppShell";
import FeedPostCard from "../../components/member-feed/FeedPostCard";

const PublicPost = ({ endUser }) => {
  const { postId } = useParams();
  const { getPublicCommunityPost } = useUser();

  const {
    data: post,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["public-community-post", postId],
    queryFn: () => getPublicCommunityPost(postId),
    refetchOnWindowFocus: false,
    retry: 1,
  });

  const handleSharePost = async () => {
    const shareUrl = `${window.location.origin}/post/${postId}`;
    try {
      if (navigator.share) {
        await navigator.share({
          title: "0709 Bangladesh Community Post",
          text: "Check out this post",
          url: shareUrl,
        });
        return;
      }

      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(shareUrl);
        toast.success("Post link copied");
        return;
      }

      toast.info(shareUrl);
    } catch (_error) {
      toast.error("Could not share post");
    }
  };

  return (
    <AppShell title="Post" back>
      <div>
        {isLoading ? (
          <div className="app-empty">Loading post…</div>
        ) : isError || !post ? (
          <div className="app-empty">Post not found.</div>
        ) : (
          <FeedPostCard
            post={post}
            commentText=""
            onCommentTextChange={() => {}}
            onCommentSubmit={() => {}}
            onLikeToggle={() => {}}
            onShare={handleSharePost}
            liking={false}
            commenting={false}
            currentUserId={endUser?._id}
            readOnly
          />
        )}
      </div>
    </AppShell>
  );
};

export default PublicPost;
